// extracted by mini-css-extract-plugin
export var btn = "sideBar-module--btn--z33QV";
export var container = "sideBar-module--container--v27PB";
export var forForm = "sideBar-module--forForm--1k8+d";
export var root = "sideBar-module--root--kfzDW";